const FRACTIONS: [number, string][] = [
  [1 / 4, '1/4'],
  [1 / 3, '1/3'],
  [1 / 2, '1/2'],
  [2 / 3, '2/3'],
  [3 / 4, '3/4'],
]

// Stored values are rounded to three decimals, so a third arrives as 0.333,
// 0.334 or 0.667 and a total can land on 0.999.
const TOLERANCE = 0.005

/**
 * A work day usually awards at most one diet, but a rest away from home or a
 * long trip is worth as many as it spans, so the whole part is kept alongside
 * the fraction. Anything the fractions do not name falls back to the number.
 */
export function formatPartOfDay(partOfDay: number): string {
  const whole = Math.floor(partOfDay + TOLERANCE)
  const remainder = partOfDay - whole
  if (Math.abs(remainder) < TOLERANCE) return String(whole)

  const fraction = FRACTIONS.find(
    ([value]) => Math.abs(remainder - value) < TOLERANCE
  )
  if (!fraction) return String(partOfDay)
  return whole ? `${whole} ${fraction[1]}` : fraction[1]
}
